import { IBaseResponse } from '@/@types/ResponseModel';
import config from '@/config';
import axiosApi from '@/core/interceptor/interceptor';
import amex from '@assets/media/images/Amex.svg';
import defaultCard from '@assets/media/images/default-card.svg';
import dinersclub from '@assets/media/images/DinersClub.svg';
import discover from '@assets/media/images/Discover.svg';
import jcb from '@assets/media/images/jcb-card.svg';
import mastercard from '@assets/media/images/Mastercard.svg';
import unionpay from '@assets/media/images/union-pay.svg';
import visa from '@assets/media/images/Visa.svg';

export function getContent(params: any): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/main-slider`, { params });
}

export function getSpecialRecipes(id: number): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/special-recipes/${id}`);
}

export function getActiveLocation(): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/active-location`);
}

export function submitContactUs(data: any): Promise<IBaseResponse<any>> {
  return axiosApi.post(`${config.apiUrl}misc/contact-us`, data);
}

export function getRecipeMenuCategories(
  id: number
): Promise<IBaseResponse<any>> {
  return axiosApi.post(`${config.apiUrl}misc/menu/${id}`);
}

export function getCurrentRestaurant(
  id: number,
  domain?: string
): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/current-restaurant/${id}`);
}

export function getReviews(): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/reviews`);
}

export function getNotifications(id: number): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/notification-banner/${id}`);
}

export function getBottomData(id: number): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/footer-data/${id}`);
}

export function getCateringeMenu(id: number): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/catering/${id}`);
}

export function getContactEmail(id: number): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/contact-email/${id}`);
}

export function getStateList(): Promise<IBaseResponse<any>> {
  return axiosApi.get(`${config.apiUrl}misc/states`);
}

export const getCardBrandIcon = (brand: string) => {
  const brandLower = brand?.toLowerCase();
  switch (brandLower) {
    case 'visa':
      return <img src={visa} alt="visa" />;
    case 'mastercard':
      return <img src={mastercard} alt="mastercard" />;
    case 'amex':
      return <img src={amex} alt="amex" />;
    case 'discover':
      return <img src={discover} alt="discover" />;
    case 'diners':
      return <img src={dinersclub} alt="dinersclub" />;
    case 'jcb':
      return <img src={jcb} alt="jcb" />;
    case 'unionpay':
      return <img src={unionpay} alt="unionpay" />;
    default:
      return <img src={defaultCard} alt="default" />;
  }
};
